import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { DataService } from '../../../../core/api/data/data.service';
import { ProductService } from '../../../../core/api/product/product.service';
import { UserService } from '../../../../core/api/user/user.service';
import { RewardService } from '../../../../core/api/reward/reward.service';
import packageInfo from '../../../../../../package.json';

@Component({
  selector: 'app-header-content-footer',
  templateUrl: './header-content-footer.component.html',
  styleUrls: ['./header-content-footer.component.scss'],
})
/**
 * Header Content Footer template
 */
export class HeaderContentFooterComponent implements OnInit {
  isMobile = false;

  /**
   * @constructor
   */
  constructor(
    private readonly authenticatedUserService: AuthenticatedUserService,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly userService: UserService,
    private readonly productService: ProductService,
    private readonly rewardService: RewardService,
    private readonly dataService: DataService
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.breakpointObserver
      .observe(['(min-width: 620px)'])
      .subscribe((state: BreakpointState) => {
        this.isMobile = !state.matches;
      });
    this.userService
      .getApiVersion()
      .subscribe((res: string) => console.log(`User API version: ${res}`));
    this.productService
      .getApiVersion()
      .subscribe((res: string) => console.log(`Product API version: ${res}`));
    this.rewardService
      .getApiVersion()
      .subscribe((res: string) => console.log(`Reward API version: ${res}`));
    this.dataService
      .getApiVersion()
      .subscribe((res: string) => console.log(`Data API version: ${res}`));
    console.log(`FE application version: ${packageInfo.version}`);
  }

  /**
   * Admin profile picture if available
   */
  get profilePicture() {
    return this.authenticatedUserService.admin?.picture || '';
  }
}
